/**
 * URL slug helpers — turn a human name into a clean, SEO-friendly path segment and back.
 * Spaces → hyphens, lowercased, accents/punctuation stripped. Used for the public agent
 * directory (/agent/{slug}) and group URLs (/group/{slug}).
 */
export function toSlug(name: string): string {
  return (name || '')
    .normalize('NFKD').replace(/[̀-ͯ]/g, '') // strip accents
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')   // non-alphanumerics → hyphen
    .replace(/^-+|-+$/g, '')        // trim leading/trailing hyphens
    .replace(/-{2,}/g, '-');        // collapse repeats
}

/** Whether a slug matches a name (slug equality, case/space-insensitive). */
export function slugMatches(name: string, slug: string): boolean {
  return toSlug(name) === toSlug(slug);
}
